<template lang='pug'>
  v-app
    Dialog
    v-main
      router-view
    v-footer(app)
      v-row(justify='center' align='center')
        p.ma-3 © {{ currentYear }} - Simplex Connect
</template>

<script>
import Dialog from '@/components/Dialog.vue';

export default {
  name: 'App',
  components: {
    Dialog
  },
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  },
};
</script>
<style lang="scss">
.v-footer {
  background-color: white !important;
  color: grey !important;
}
.loader {
  position: absolute !important;
  top: 50%;
  left: 50%;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
}

/* Shared scrollbar styling */
.custom-scrollbar {
  max-height: 90vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #00a38c #e0e0e0;
}

/* Webkit browsers */
.custom-scrollbar::-webkit-scrollbar {
  width: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #00a38c;
  border-radius: 8px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 8px;
}
</style>